import { render, staticRenderFns } from "./BssDetail.vue?vue&type=template&id=0521784e&scoped=true"
import script from "./BssDetail.vue?vue&type=script&lang=js"
export * from "./BssDetail.vue?vue&type=script&lang=js"
import style0 from "./BssDetail.vue?vue&type=style&index=0&id=0521784e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0521784e",
  null
  
)

export default component.exports